module.exports = __webpack_public_path__ + "img/lose.7274cd37.gif";